import React, { useState } from "react";
import { Jumbotron } from "react-bootstrap";
import "../css/App.css";
import { useSpring, animated } from "react-spring";
import { scroller } from "react-scroll";
import { isMobile } from "react-device-detect";
import InView from "react-intersection-observer";

export default function Home() {
  const [showH2, setShowH2] = useState(false);

  function scrollToAbout() {
    if (isMobile) {
      scroller.scrollTo("aboutMeScroll", {
        duration: 0,
        delay: 500,
        smooth: "easeOutQuad",
        offset: 50,
      });
    } else {
      scroller.scrollTo("aboutMeScroll", {
        duration: 0,
        delay: 0,
        smooth: "easeOutQuad",
        offset: 0,
      });
    }
  }
  const props = useSpring({
    from: { opacity: 0, marginLeft: showH2 ? -150 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginLeft: 0 },
    config: { mass: 1, tension: 100, friction: 60 },
  });
  const props2 = useSpring({
    from: { opacity: 0, marginLeft: showH2 ? -150 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginLeft: 100 },
    delay: 200,
    config: { mass: 1, tension: 100, friction: 50 },
  });

  const props3 = useSpring({
    from: { opacity: 0, marginTop: showH2 ? -150 : 0 },
    to: { opacity: showH2 ? 1 : 0, marginTop: 0 },
    delay: 200,
    config: { mass: 1, tension: 100, friction: 50 },
  });
  var onInViewChange2 = (inview) => {
    if (!showH2 && inview) setShowH2(true);
  };

  return (
    <div
      className="container"
      style={{ marginTop: "20vh", height: "100vh", overflowX: "hidden" }}
      id="homeDiv"
    >
      <Jumbotron fluid>
        <InView onChange={onInViewChange2}>
          <animated.div style={props}>
            <span id="intro">
              <h1 class="headers ms-5">
                Hi, My Name is <span className="colored">Neeleshwar Kumar</span>
              </h1>
              <h1 class="headers ms-5 mt-3">
                I build apps for <span className="colored">Web </span> and{" "}
                <span className="colored">Mobile</span>
              </h1>
            </span>
          </animated.div>
          <animated.div style={props2}>
            <button
              id="knowMoreButton"
              className="btn btn-background-slideWhite ms-5 mt-5"
              onClick={scrollToAbout}
            >
              <strong className="strong" id="knowMore">
                Know more!
              </strong>
            </button>
          </animated.div>
        </InView>
        <InView onChange={onInViewChange2}>
          <animated.div style={props3}>
            <h1 class="ms-4" id="curText" style={{ marginTop: "20vh" }}>
              Currently working as a Full Stack Engineer at
              <br />
              <span className="colored"> Sleepiz.</span>
            </h1>
          </animated.div>
        </InView>
      </Jumbotron>
    </div>
  );
}
